import React from "react";

import { Button } from "react-bootstrap";
import { DeepPartial, FieldValues, Resolver, SubmitHandler, UnpackNestedValue, useForm } from "react-hook-form";

type VerticalFromProps<TFormValues extends FieldValues> = {
    defaultValues?: UnpackNestedValue<DeepPartial<TFormValues>>;
    resolver?: Resolver<TFormValues>;
    children?: React.ReactNode;
    onSubmit: SubmitHandler<TFormValues>;
    formClass?: string;
    cancelCb?: () => void;
    hasBtn?: boolean;
    hasCancelBtn?: boolean;
    submitBtnLabel?: string;
};

const VerticalForm = <TFormValues extends Record<string, any> = Record<string, any>>({
    defaultValues,
    resolver,
    children,
    onSubmit,
    formClass,
    cancelCb,
    hasCancelBtn = true,
    submitBtnLabel = "確認",
    hasBtn = true,
}: VerticalFromProps<TFormValues>) => {
    /*
     * form methods
     */
    const methods = useForm<TFormValues>({ defaultValues, resolver, mode: "all" });
    const { handleSubmit, register, control, formState, reset } = methods;
    const { errors } = formState;

    // console.log("== 🐑  == formState: ", formState.isDirty, formState.isValid);

    const handleCancel = () => {
        if (cancelCb) {
            cancelCb();
        }
        if (defaultValues) {
            return reset(undefined, { keepDefaultValues: true });
        }
        reset();
    };
    return (
        <form onSubmit={handleSubmit(onSubmit)} className={formClass} noValidate>
            {Array.isArray(children)
                ? children.map((child) => {
                      return child.props && child.props.name
                          ? React.createElement(child.type, {
                                ...{
                                    ...child.props,
                                    register,
                                    key: child.props.name,
                                    errors,
                                    control,
                                },
                            })
                          : child;
                  })
                : children}
            <div className='text-md-end mb-0'>
                {hasCancelBtn && cancelCb && (
                    <Button className='me-2' variant='secondary' type='button' onClick={handleCancel}>
                        取消
                    </Button>
                )}
                {hasBtn && (
                    <Button
                        variant='primary'
                        type='submit'
                        disabled={!formState.isDirty || (formState.isDirty && !formState.isValid)}
                    >
                        {submitBtnLabel}
                    </Button>
                )}
            </div>
        </form>
    );
};

export default VerticalForm;
